// Public comments use the existing custom invoice item and ordinary invoice save.
// Keep reading the earlier experimental marker so existing drafts can be reopened.
export const isCommentInvoiceLine = item => Boolean(item && (item.commentOnly === true || item.lineType === "comment"));
const publicFields = ["id", "lineId", "productId", "description", "desc", "note", "listId", "listName", "sectionId", "sectionName", "itemId", "itemName", "invoiceGroupOrder"];
export function projectCommentInvoiceLine(item = {}) {
  if (!isCommentInvoiceLine(item)) return item;
  const result = { lineType: "custom", recordType: "custom", commentOnly: true };
  publicFields.forEach(key => {
    if (typeof item[key] === "string" || typeof item[key] === "number") result[key] = item[key];
  });
  // Older numeric readers need finite neutral values. Updated UIs leave them blank.
  return { ...result, customItem: { source: "manual", note: result.note || "" },
    qty: 1, rate: 0, value: 0, discount: 1, skipPricingMode: true };
}
export const normalizeCommentInvoiceLine = projectCommentInvoiceLine;
